export const SET_COLUMN_LIST = 'SET_COLUMN_LIST'
export const SET_COLUMN_DETAIL = 'SET_COLUMN_DETAIL'
export const SET_COLUMN_CATEGORY = 'SET_COLUMN_CATEGORY'
export const SET_COLUMN_LIST_GENERIC = 'SET_COLUMN_LIST_GENERIC'
